import { memo } from 'react';
import {
  Fade,
  AccordionDetails,
  Grid,
  Hidden,
  Typography
} from '@material-ui/core';
import { GigTableRow } from './GigTableRow';
import { useBoardContext } from '../hooks/useBoardContext';

const ColumnHeader = ({ text, xs, md, align = 'center' }) => (
  <Grid item {...{ xs, md }}>
    <Typography variant="subtitle2" align={align}>
      {text}
    </Typography>
  </Grid>
);

export const GigTable = memo(
  ({
    classes,
    gigs,
    boardId,
    showFirstAndLastName,
    textlineGroupUuid,
    children,
    bucketId,
    headerColorClass,
    groupIndex = 0,
    isNested = false
  }) => {
    const { setGigExpandedState, bucketsExpandedState } = useBoardContext();
    const isGigExpanded = (gigId) => {
      return (
        bucketsExpandedState[bucketId]?.groups?.[groupIndex]?.gigs?.[gigId]
          ?.isExpanded || false
      );
    };
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          wrap="nowrap"
          className={`${classes.titlePadding} ${headerColorClass}`}
        >
          <ColumnHeader
            md={3}
            xs={8}
            text="Title"
            align="left"
            className={isNested && classes.columnTitle}
          />
          <Hidden smDown>
            <ColumnHeader md={2} text="Value" align="left" />
            <ColumnHeader md={2} text="Distance" align="left" />
            <ColumnHeader md={3} text="Last Event" align="left" />
            <ColumnHeader md={3} text="Driver" align="left" />
            <ColumnHeader md={2} text="Target" align="left" />
          </Hidden>
          <ColumnHeader md={2} xs={4} text="Deadline" align="left" />
        </Grid>
        <AccordionDetails className={classes.panelDetails}>
          {gigs?.length > 0 && (
            <Fade in>
              <div className={classes.gigRow}>
                {gigs.map((gig) => (
                  <GigTableRow
                    gig={gig}
                    key={gig.id}
                    boardId={boardId}
                    showFirstAndLastName={showFirstAndLastName}
                    textlineGroupUuid={textlineGroupUuid}
                    bucketId={bucketId}
                    isGigExpanded={isGigExpanded(gig.id)}
                    setGigExpandedState={(_, isExpanded) =>
                      setGigExpandedState(
                        gig.id,
                        bucketId,
                        isExpanded,
                        groupIndex
                      )
                    }
                  />
                ))}
                {children}
              </div>
            </Fade>
          )}
        </AccordionDetails>
      </div>
    );
  }
);
